module.exports = __webpack_public_path__ + "static/media/26.06d140da.jpg";